import { Button, styled, Typography } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(6, 12),
  [theme.breakpoints.down('md')]: {
    a: {
      width: '100%',
    },
  },
}));

export const CatalogueWrapper = styled('div', {
  shouldForwardProp: shouldForwardProp(),
})(({ theme }) => ({
  margin: theme.spacing(3, 3, 10, 3),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: theme.spacing(6),

  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(6, 12, 0, 12),
  },
}));

export const Catalogue = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',

  a: {
    minWidth: 160,
  },
}));

export const CatalogueDetailButton = styled(Button)<{ hoverEffect?: boolean }>(({ theme, hoverEffect = false }) => ({
  margin: theme.spacing(2, 'auto'),

  '&:hover': {
    background: hoverEffect ? theme.palette.grey : 'none',
  },
}));

export const CatalogueLink = styled('a')<{ hoverEffect?: boolean }>(({ theme, hoverEffect = false }) => ({
  textDecoration: 'none',
  '&:hover': {
    color: hoverEffect ? theme.palette.default.light : 'none',
  },
}));

export const CallToActionWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  margin: theme.spacing(0, 12),
}));

export const CallToAction = styled('div')(({ theme }) => ({
  width: 330,
  marginBottom: theme.spacing(4),
}));

export const CTAText = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem',
  textAlign: 'center',
  textDecoration: 'underline',
  textTransform: 'uppercase',
  textUnderlineOffset: theme.spacing(1),
  textDecorationThickness: 2,
  margin: theme.spacing(3, 0, 0),
  fontWeight: theme.typography.fontWeightBold,

  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.subtitle1.fontSize,
    textAlign: 'left',
    textDecoration: 'none',
    textTransform: 'none',
    textUnderlineOffset: 'auto',
    textDecorationThickness: 'auto',
    margin: theme.spacing(0),
  },
}));

export const MobileWrapper = styled('div')(() => ({
  height: 103,
  width: '100%',
}));
